"use strict";

exports.__esModule = true;
exports["default"] = camelizeStyleName;

var _stringFormatter = require("./stringFormatter");

var msPattern = /^-ms-/;

function camelizeStyleName(name) {
  // The `-ms` prefix is converted to lowercase `ms`.
  // http://www.andismith.com/blog/2012/02/modernizr-prefixed/
  return (0, _stringFormatter.camelize)(name.replace(msPattern, 'ms-'));
}

module.exports = exports.default;